var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"shapeRendering":"geometricPrecision","d":"M22.062 54.322c20.217 0 31.273-17.174 31.273-32.066 0-.489-.01-.974-.032-1.458a22.69 22.69 0 005.484-5.835 21.531 21.531 0 01-6.312 1.774 11.262 11.262 0 004.833-6.234 21.697 21.697 0 01-6.98 2.735c-2.005-2.19-4.862-3.56-8.022-3.56-6.071 0-10.994 5.047-10.994 11.27 0 .884.097 1.744.285 2.569-9.134-.47-17.235-4.956-22.655-11.775a11.448 11.448 0 00-1.488 5.664c0 3.91 1.94 7.362 4.89 9.382a10.71 10.71 0 01-4.978-1.41c-.002.047-.002.094-.002.144 0 5.458 3.79 10.015 8.818 11.049a10.711 10.711 0 01-4.964.193c1.4 4.477 5.457 7.736 10.269 7.828-3.763 3.023-8.502 4.824-13.652 4.824-.887 0-1.761-.052-2.622-.156 4.865 3.197 10.64 5.062 16.849 5.062","fill":"currentColor","fillRule":"evenodd"}));
}

Twitter.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Twitter;

Twitter.default = Twitter;
